var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TableOrder"},[_c('div',[_c('phoneTable',{ref:"phonetablechild",attrs:{"partition":_vm.partition},on:{"exportSuccess":_vm.exportSuccess}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }